import { LOAD, UPDATE } from 'model/fspFraudConfig';
import { formatSuccessMessage, UPDATED, FSP_FRAUD_CONFIG_LABEL } from 'consts';
import { load, update } from 'sdk/fspFraudConfig';
import { takeEvery } from 'redux-saga/effects';
import { callAction, ORM } from '../util';
import { loadFSPProfileAction } from './export';
import {
  createDenyListConfigAction,
  updateDenyListConfigAction,
} from './fspDenyListConfig';

const keyName = { key: '', name: FSP_FRAUD_CONFIG_LABEL };

export const updateFSPFraudConfig = () =>
  callAction({
    api: update,
    dataName: ORM,
    formatSuccessMessage: formatSuccessMessage(keyName, UPDATED, false),
    type: UPDATE,
  });

function* updateAndPopulateExport(action) {
  const updateAction = updateFSPFraudConfig();

  if (yield updateAction(action)) {
    yield loadFSPProfileAction(action);

    // Calls the actions to create or update the DenyListConfig (global)
    if (action.data.updateDLOfferings) {
      if (!action.data.hasDLConfig) {
        yield createDenyListConfigAction(action);
      } else {
        yield updateDenyListConfigAction(action);
      }
    }
  }
}

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(UPDATE.ACTION, updateAndPopulateExport);
}
